export const getKeyProductFeaturePodCategories = (categoriesConfig) => {
  if (typeof categoriesConfig !== 'string') {
    return [];
  }

  return categoriesConfig
    .split(',')
    .map((value) => value.trim())
    .filter(Boolean);
};

export const hasKeyProductFeaturePodCategoryMatch = (categoriesConfig, navValue) => {
  const categories = getKeyProductFeaturePodCategories(categoriesConfig);
  const safeNavValue = typeof navValue === 'string' ? navValue : '';

  if (!safeNavValue || !categories.length) {
    return false;
  }

  return categories.some((value) => safeNavValue.includes(value));
};

export const getIsSkipKPF = ({
  categoriesConfig,
  navValue,
  channel,
  experienceType
} = {}) => {
  // Mobile and MA always request KPF, for B2B and B2C alike.
  if (channel === 'mobile' || experienceType === 'ma') {
    return false;
  }

  return !hasKeyProductFeaturePodCategoryMatch(categoriesConfig, navValue);
};
